// extracted by mini-css-extract-plugin
export default {"icon":"dropdownIndicator_icon__73ppx"};